import Table from "./table";

export { default as Table } from "./table";

export const Column = Table.Column;
export const ColumnGroup = Table.ColumnGroup;
